import api from '../../../../api/client';


export const leaveBalanceApi = {
  async getSummary(empId) {
    try {
      const response = await api.get('/self-service/leave-balance/', {
        params: empId ? { emp_id: empId } : {},
      });
      return {
        data: response.data.items || [],
        total: response.data.total_count || (response.data.items || []).length,
      };
    } catch (err) {
      console.warn('Failed to fetch leave balance summary:', err);
      return { data: [], total: 0 };
    }
  },

  async getLedger(empId) {
    try {
      const response = await api.get('/self-service/leave-balance/ledger', {
        params: empId ? { emp_id: empId } : {},
      });
      return {
        data: response.data.items || [],
        total: response.data.total_count || (response.data.items || []).length,
      };
    } catch (err) {
      console.warn('Failed to fetch leave ledger from server:', err);
      return { data: [], total: 0 };
    }
  },
};
